import type { IUserStoreMarketCustomer } from '../models';

export class UserStoreConfig {
  public static readonly REQUIRED_FIELDS = ['name', 'email'];

  static MARKET_CUSTOMER_DEFAULT(): IUserStoreMarketCustomer {
    return { customerId: '', accountId: '' };
  }
}
